var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgPartnerCreated = function SvgImgPartnerCreated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 211,
    viewBox: "0 0 221 211",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2309 190.717L55.7695 189.345L54.3972 197.806L62.8585 199.178L64.2309 190.717Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.572 101.762L121.585 59.7131L48.7627 96.1374L62.7848 124.164L107.572 101.762Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2249 109.052L56.4544 92.2831L52.9053 104.413L55.2249 109.052Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 101.763L62.7842 124.164L85.185 168.955L129.977 146.554L107.576 101.763Z",
    fill: "#EFEFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1592 142.904L110.964 156.054L105.156 158.958C97.4391 160.24 83.7658 156.481 75.5426 149.671L72.1592 142.904Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1729 211L105.155 194.004L85.1775 168.951L71.1729 211Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.685 110.412C192.333 109.296 192.9 107.134 192.01 105.346L159.17 39.6915C158.097 37.5463 155.385 36.8313 153.397 38.1829L121.577 59.7131L157.993 132.527L190.685 110.412Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.101 25.1288C106.212 23.0098 103.718 22.0854 101.66 23.1144L35.9706 55.9721C34.1045 56.9052 33.2761 59.1289 34.087 61.056L48.7719 96.1374L121.586 59.7218L107.101 25.1288Z",
    fill: "#EFEFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2803 175.23L71.1741 211L85.1788 168.951L53.2803 175.23Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.974 146.549L158.001 132.536L121.586 59.7131L107.572 101.762L129.974 146.549Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.832 156.22C135.444 156.22 158.639 133.025 158.639 104.413C158.639 75.8008 135.444 52.6061 106.832 52.6061C78.2201 52.6061 55.0254 75.8008 55.0254 104.413C55.0254 133.025 78.2201 156.22 106.832 156.22Z",
    fill: "#286DF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.882 92.6581L100.204 112.758L91.4399 102.137L88.0303 104.962L99.7764 119.194L124.891 95.9107L121.882 92.6581Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.785 124.164L48.7629 96.1374L17.6841 102.25C15.1117 102.756 13.7252 105.573 14.9024 107.918L47.638 173.372C48.4403 174.968 50.2018 175.84 51.9545 175.491L53.2887 175.23L85.1872 168.96L62.785 124.164Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.799 158.626L157.992 132.536L129.966 146.549L85.1787 168.951L105.148 193.996L107.032 196.359C108.2 197.824 110.232 198.277 111.915 197.431L177.473 164.643C179.732 163.518 180.377 160.597 178.799 158.626Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1787 168.951L105.157 194.004L97.448 197.859L85.1787 168.951Z",
    fill: "#BDBDBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1788 168.951L53.2803 175.23L57.3701 183.4L85.1788 168.951Z",
    fill: "#BDBDBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.565 63.7854L186.577 54.1234C197.687 52.0916 207.288 47.1298 215.371 39.2468L220.359 48.9088C211.665 55.6233 202.064 60.5764 191.565 63.7854Z",
    fill: "#FFBF00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58351 42.046L0 48.6385C2.98231 57.4197 10.7695 71.372 19.3676 76.7786L28.9511 70.1861C19.4548 64.8232 12.4786 52.955 9.58351 42.046Z",
    fill: "#EFEFEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M185.768 135.753L187.477 144.735C189.352 146.906 197.889 146.654 208.301 140.767L206.591 131.786C197.993 137.314 190.555 137.925 185.768 135.753Z",
    fill: "#EFEFEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.409 19.4345H141.895V25.9485H148.409V19.4345Z",
    fill: "#EFEFEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.039 199.46L160.946 197.155L158.642 203.248L164.734 205.552L167.039 199.46Z",
    fill: "#EFEFEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3781 5.83022L63.0098 0.998138L58.1777 5.36642L62.546 10.1985L67.3781 5.83022Z",
    fill: "#FFBF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1976 119.909C29.858 118.845 24.5997 116.386 20.1611 112.871L23.126 106.122C27.7652 109.854 33.163 112.104 39.1625 113.159L36.1976 119.909Z",
    fill: "#FFBF00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgPartnerCreated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_partner_created.26a7a669.svg";
export { ForwardRef as ReactComponent };